import { Modal } from 'react-bootstrap';

const ModalUnidade = ({ show, onHide, unidadeEditando, register, errors, handleSubmit, onSubmit, loading }) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" size="lg">
            <form
                onSubmit={(e) => {
                    e.stopPropagation();
                    handleSubmit(onSubmit)(e);
                }}
            >
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-5 text-primary">
                        {unidadeEditando ? 'Editar unidade' : 'Nova unidade'}
                    </span>
                </Modal.Header>
                <Modal.Body className="bg-gray-100 p-4">
                    <div className="mb-3">
                        <label className="form-label text-primary fw-medium">Nome da unidade</label>
                        <input
                            type="text"
                            {...register('nome', { required: 'Nome é obrigatório' })}
                            placeholder="Ex: Operações"
                            className="form-control border-new-light"
                        />
                        {errors.nome && <span className="text-danger fs-7">{errors.nome.message}</span>}
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-end">
                    <button type="button" className="btn me-2" onClick={onHide} disabled={loading}>
                        Cancelar
                    </button>
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Salvando...
                            </>
                        ) : (
                            'Salvar'
                        )}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default ModalUnidade;
